var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C10.2091 2 12 3.79086 12 6C12 8.03975 10.4731 9.72165 8.5 9.96777V10.998L9.50098 11C9.77704 11.0005 10.0004 11.2249 10 11.501C9.99946 11.777 9.77511 12.0004 9.49902 12L8.5 11.998V13.5C8.5 13.7761 8.27614 14 8 14C7.72386 14 7.5 13.7761 7.5 13.5V11.9961L6.49902 11.9951C6.22296 11.9946 5.99955 11.7702 6 11.4941C6.00054 11.2181 6.22489 10.9947 6.50098 10.9951L7.5 10.9961V9.96777C5.52692 9.72165 4 8.03975 4 6C4 3.79086 5.79086 2 8 2ZM8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.c1f1742779bdabf47074778abe3efd78.svg";
export { ForwardRef as ReactComponent };